/**
 * Cost
 */
export const Cost = {
  month: 18.8,
  year: 225.6,
};

export interface tierData {
  tier: string;
  min: number;
  max: number;
  Software: number;
  SaaS: number;
}

export const Tiers: tierData[] = [
  {
    tier: 'T4',
    min: 999,
    max: 10000000,
    Software: 0.33,
    SaaS: 0.25,
  },
  {
    tier: 'T3',
    min: 499,
    max: 999,
    Software: 0.22,
    SaaS: 0.15,
  },
  {
    tier: 'T2',
    min: 199,
    max: 499,
    Software: 0.16,
    SaaS: 0.13,
  },
  {
    tier: 'T1',
    min: 0,
    max: 199,
    Software: 0.16,
    SaaS: 0.13,
  },
];
